<div cdkTrapFocus [cdkTrapFocusAutoCapture]="true">
  <modal-header-default class="border"> </modal-header-default>
  <div>
    @if (vm$ | async; as vm) {
      @if (vm.hasError) {
        <bp-try-again-error
          [title]="'web3_signup_heading_error' | translate"
          [message]="'web3_signup_description_error' | translate"
          [tryAgainMessage]="'try_again' | translate"
        (onRetry)="tryAgain()"></bp-try-again-error>
      } @else {
        <div class="inside-container">
          <div class="heading-holder">
            <h4 class="headline"> {{ "web3_signup_heading" | translate }}</h4>
            <p class="description"> {{ "web3_signup_description" | translate }}</p>
          </div>
          <web3-display-ui [amount]="vm.amount" [tradable]="visionTradables$ | async"></web3-display-ui>
          <web3-remaining-asset-ui [availableAssets]="vm.availableAssets"></web3-remaining-asset-ui>

          <div class="how-to-box">
            <collapsible-container-ui [showLine]="true">
            <p heading class="price-guarateed"> {{ "web3_signup_how_text" | translate }} </p>
            <!-- data for the fees -->
            <div class="description">
              <p>{{ "web3_how_description_line1" | translate }}</p>
              <p class="rates-title">{{ "web3_how_description_rates" | translate }}</p>
              <div class="rates-container">
                <span>{{ "web3_how_description_rate_best" | translate }}</span>
                <span>{{ "web3_how_description_rate_pan" | translate }}</span>
              </div>

              <p
                >{{ "web3_how_description_line3" | translate }}
                <a class="link" [href]="whitepaperUrl" target="_blank">{{
                  "web3_how_description_line3_link" | translate
                }}</a></p
                >

                @if (!isUKUser) {
                  <p
                    >{{ "web3_how_description_line4" | translate }}

                    <a class="link" [href]="visionLoyaltyProgrammeUrl" target="_blank">{{
                      "web3_how_description_line4_link" | translate
                    }}</a></p
                    >
                  }
                </div>
              </collapsible-container-ui>
            </div>

            <div class="terms">
              <!-- dynamic -->
              <terms-and-conditions-updates [bundles]="vm.bundles"></terms-and-conditions-updates>
            </div>
          </div>

          <div class="button-holder">
            @if (!isFormValid) {
              <button class="fake-button" (click)="wiggleToggles()"></button>
            }
            <button
              (click)="next(vm.phase, vm.amount)"
              class="btn btn-primary next-btn"
              [disabled]="!isFormValid">
              {{ "summary_button_confirm" | translate }}
            </button>
          </div>
        }
      } @else {
        <div class="loader-holder">
          <loading-spinner class="green loader-big no-padding"></loading-spinner>
        </div>
      }
    </div>
  </div>
